/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useAdminEmptyListStyles = makeStyles(theme => ({
  emptyMessageBlock: {
    color: theme.palette.text.primary,
    padding: '15px 20px',
    fontSize: '14px',
  },
}));
